/**
 * 점주 콘솔 v2 — 매장 공개 노출 관리 API (master 전용).
 * 백엔드 stores 컨트롤러(@Roles('master'))를 직접 호출한다.
 */
import api from '../../api/client';

/** 승인 매장 목록 + 공개 노출 상태 */
export async function fetchWebsiteStores() {
  const res = await api.get('/stores/website-manage');
  return res.data;
}

/** 매장 공개 노출 플래그 저장 — PATCH /stores/:id */
export async function updateStoreVisibility(storeId, payload) {
  const res = await api.patch(`/stores/${storeId}`, payload);
  return res.data;
}
